export const USER_ROLE_LABEL = 'User Role:';
